module.exports = "pegasus_template/assets/circleline-tumblr.png";